// Concept of Sustainability page Indonesian translations

export default {
  pageTitle: "Konsep Keberlanjutan",
  breadcrumbHome: "Beranda",
  breadcrumbSustainability: "Keberlanjutan",
  breadcrumbCurrent: "Konsep Keberlanjutan",
  
  // Header section
  title: "Konsep Keberlanjutan Kami",
  
  // Concept details section
  conceptTitle: "Konsep Keberlanjutan Eagle Industry",
  conceptDesc1: "Di Eagle Industry Indonesia, kami percaya bahwa perusahaan tidak hanya milik pemegang saham tetapi juga karyawan dan masyarakat. Filosofi ini telah lama meresap ke setiap aspek manajemen Grup EKK sejak pendirian kami pada tahun 1996.",
  conceptDesc2: "Sebagai bagian dari Eagle Industry Co., Ltd., pemimpin global dalam solusi sealing, kami berkontribusi pada perlindungan lingkungan melalui bisnis inti kami. Mechanical seal kami mencegah gas, minyak, dan fluida lainnya bocor dari mesin, secara langsung membantu melestarikan lingkungan dan mencegah polusi.",
  
  // Sustainability vision section
  visionTitle: "Visi Keberlanjutan Kami",
  visionDesc: "Kami bertujuan untuk menciptakan nilai berkelanjutan bagi semua pemangku kepentingan dengan mengintegrasikan pertimbangan lingkungan, sosial, dan tata kelola (ESG) ke dalam strategi bisnis kami. Visi kami adalah menjadi mitra tepercaya yang berkontribusi pada masyarakat melalui solusi sealing inovatif sambil menjaga harmoni dengan lingkungan global.",
  
  // Core principles section
  principlesTitle: "Prinsip Keberlanjutan Inti",
  principle1Title: "Perlindungan Lingkungan",
  principle1Desc: "Melalui teknologi pencegahan kebocoran",
  principle2Title: "Membangun Kepercayaan",
  principle2Desc: "Melalui dialog dengan semua pemangku kepentingan",
  principle3Title: "Keuntungan yang Adil",
  principle3Desc: "Yang mendukung pertumbuhan abadi",
  principle4Title: "Pengembangan Produk",
  principle4Desc: "Yang mengatasi masalah regulasi lingkungan",
  principle5Title: "Hak Asasi Manusia",
  principle5Desc: "Dan kesehatan dan keselamatan kerja",
  principle6Title: "Kontribusi Masyarakat",
  principle6Desc: "Dan konservasi keanekaragaman hayati",
  
  // Long-term goals section
  goalsTitle: "Tujuan Keberlanjutan Jangka Panjang",
  goalsDesc: "Kami telah menetapkan tujuan jangka panjang yang sejalan dengan kerangka keberlanjutan global, termasuk Tujuan Pembangunan Berkelanjutan PBB (SDGs) dan Perjanjian Paris. Komitmen kami melampaui kepatuhan untuk menjadi pemimpin proaktif dalam praktik bisnis berkelanjutan.",
  
  // Quote section
  quoteText: "Keberlanjutan bukan hanya tanggung jawab tetapi kesempatan untuk berinovasi dan menciptakan nilai abadi bagi pemangku kepentingan dan masyarakat kami.",
  quoteAuthor: "Manajemen, Eagle Industry Indonesia",
  
  // Sustainability pillars section
  pillarsTitle: "Pilar Keberlanjutan Kami",
  pillarsSubtitle: "Elemen inti dari kerangka keberlanjutan kami",
  pillar1Title: "Lingkungan",
  pillar1Desc: "Meminimalkan dampak lingkungan melalui produk dan proses inovatif yang mencegah polusi dan menghemat sumber daya.",
  pillar2Title: "Sosial",
  pillar2Desc: "Menciptakan nilai bagi masyarakat melalui praktik bisnis yang bertanggung jawab, pengembangan karyawan, dan keterlibatan masyarakat.",
  pillar3Title: "Tata Kelola",
  pillar3Desc: "Mempertahankan standar tinggi tata kelola perusahaan untuk memastikan transparansi, akuntabilitas, dan perilaku bisnis yang etis.",
  
  // Related topics section
  relatedTitle: "Topik Keberlanjutan Terkait",
  relatedSubtitle: "Jelajahi lebih lanjut tentang inisiatif keberlanjutan kami",
  related1Title: "Inisiatif Lingkungan",
  related2Title: "Inisiatif Kontribusi Sosial",
  related3Title: "Kesehatan & Keselamatan Kerja"
};